import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import SectionPaper from "../../widgets/SectionPaper";
import PageTitle from "../../widgets/PageTitle";
import ColorsTab from "./tabs/ColorsTab";
import AdjacenciesTab from "./tabs/AdjacenciesTab";
import EquivalencesTab from "./tabs/EquivalencesTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    sx={{ pt: 2, height: "calc(100% - 48px)" }}
  >
    {value === index && children}
  </Box>
);

const Colors: React.FC = () => {
  const [tab, setTab] = useState(0);

  // One card for the whole page: the tab bar and every panel (tables and the panels below them) live
  // inside a single SectionPaper — the tabs switch content within the card, they are not each a card.
  return (
    <SectionPaper sx={{ width: "100%" }}>
      <PageTitle />
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Colors" />
        <Tab label="Equivalences" />
        <Tab label="Adjacencies" />
      </Tabs>

      <TabPanel value={tab} index={0}>
        <ColorsTab />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <EquivalencesTab />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <AdjacenciesTab />
      </TabPanel>
    </SectionPaper>
  );
};

export default Colors;
